export function getApiUrl() {
    return "/app/api";
  }
  